<ion-content>
  <div
  style="display: flex; padding: 16px 16px 8px 16px; border-radius: 16px !important; background: white; box-shadow: 0px 6px 30px 0px #F1EEF2CC; align-items: center; justify-content: space-between;">
  <div class="body-md-semibold" style="color: #2E2637;">
    My Businesses
  </div>
  <ion-icon (click)="this.popoverCtrl.dismiss()"
    style="font-size: 25px; color: #1E1725; margin-bottom: 4px; cursor: pointer" name="close">
  </ion-icon>
</div>

<div style="padding: 16px; background-color: #f7f5f8;">


  <div class="body-md-semibold" (click)="startNewBusiness()"
    style="display: flex; background: white; color: #2E2637; cursor: pointer; align-items: center; gap: 12px; border: 1px solid #E4E0EB; padding: 16px; border-radius: 8px; margin-bottom: 16px; ">
    <ion-icon style="font-size: 25px;" src="assets/svg/building-purple.svg">

    </ion-icon>

    Add a Business
  </div>

  <div class="body-md-semibold"
    *ngIf="currentUser['isPartner'] === true && currentUser?.['partner_info']?.['status'] === 3"
    (click)="generatePartnerLink()"
    style="display: flex; background: white; color: #2E2637; cursor: pointer; align-items: center; gap: 12px; border: 1px solid #E4E0EB; padding: 16px; border-radius: 8px;">
    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
    </svg>
    Copy Link
  </div>



  <div style="height: 1px; width: 100%; border-bottom: 1px solid #E4E0EB; margin: 16px 0;">

  </div>

  <app-input-field (valueChange)="filterCompanyList()"
    [(ngModel)]="searchValue" placeholder="Search company name..." title="">
  </app-input-field>

  <div *ngFor="let company of companyList" class="body-md-semibold" (click)="changeDefaultCompany(company)"
    style="display: flex; background: white; color: #2E2637; margin-bottom: 12px;  cursor: pointer; align-items: center; gap: 20px; border: 1px solid #E4E0EB; padding: 16px; border-radius: 8px;">
    {{ company['display_name'] }}
  </div>

</div>
</ion-content>